var j = Object.defineProperty;
var $ = Object.getOwnPropertySymbols;
var L = Object.prototype.hasOwnProperty, B = Object.prototype.propertyIsEnumerable;
var v = (r, a, e) => a in r ? j(r, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[a] = e, s = (r, a) => {
  for (var e in a || (a = {}))
    L.call(a, e) && v(r, e, a[e]);
  if ($)
    for (var e of $(a))
      B.call(a, e) && v(r, e, a[e]);
  return r;
};
import "react";
import "react/jsx-runtime";
import { c as w, n as F, b as P, s as G, t as H, v as I, w as U } from "./factory-ueRxoNOV.js";
const W = {};
function Y(r) {
  const a = {};
  return r.forEach((e) => {
    Object.entries(e).forEach(([n, u]) => {
      a[n] ? a[n] = w(a[n], u) : a[n] = u;
    });
  }), a;
}
function E({ theme: r, classNames: a, props: e, stylesCtx: n }) {
  const c = (Array.isArray(a) ? a : [a]).map(
    (f) => typeof f == "function" ? f(r, e, n) : f || W
  );
  return Y(c);
}
function T({ theme: r, styles: a, props: e, stylesCtx: n }) {
  return (Array.isArray(a) ? a : [a]).reduce((c, f) => typeof f == "function" ? s(s({}, c), f(r, e, n)) : s(s({}, c), f), {});
}
const q = {
  always: "mantine-focus-always",
  auto: "mantine-focus-auto",
  never: "mantine-focus-never"
};
function z({ theme: r, options: a, unstyled: e }) {
  return w(
    (a == null ? void 0 : a.focusable) && !e && (r.focusClassName || q[r.focusRing]),
    (a == null ? void 0 : a.active) && !e && r.activeClassName
  );
}
function D({
  selector: r,
  stylesCtx: a,
  options: e,
  props: n,
  theme: u
}) {
  return E({
    theme: u,
    classNames: e == null ? void 0 : e.classNames,
    props: (e == null ? void 0 : e.props) || n,
    stylesCtx: a
  })[r];
}
function O({
  selector: r,
  stylesCtx: a,
  theme: e,
  classNames: n,
  props: u
}) {
  return E({ theme: e, classNames: n, props: u, stylesCtx: a })[r];
}
function J({ rootSelector: r, selector: a, className: e }) {
  return r === a ? e : void 0;
}
function K({ selector: r, classes: a, unstyled: e }) {
  return e ? void 0 : a[r];
}
function Q({
  themeName: r,
  classNamesPrefix: a,
  selector: e,
  withStaticClass: n
}) {
  return n === !1 ? [] : r.map((u) => `${a}-${u}-${e}`);
}
function X({
  themeName: r,
  theme: a,
  selector: e,
  props: n,
  stylesCtx: u
}) {
  return r.map(
    (c) => {
      var f, t;
      return (t = E({
        theme: a,
        classNames: (f = a.components[c]) == null ? void 0 : f.classNames,
        props: n,
        stylesCtx: u
      })) == null ? void 0 : t[e];
    }
  );
}
function Z({
  options: r,
  classes: a,
  selector: e,
  unstyled: n
}) {
  return r != null && r.variant && !n ? a[`${e}--${r.variant}`] : void 0;
}
function R({
  theme: r,
  options: a,
  themeName: e,
  selector: n,
  classNamesPrefix: u,
  classNames: c,
  classes: f,
  unstyled: t,
  className: g,
  rootSelector: S,
  props: l,
  stylesCtx: m,
  withStaticClasses: N,
  headless: y,
  transformedStyles: C
}) {
  return w(
    z({ theme: r, options: a, unstyled: t || y }),
    X({ theme: r, themeName: e, selector: n, props: l, stylesCtx: m }),
    Z({ options: a, classes: f, selector: n, unstyled: t }),
    O({ selector: n, stylesCtx: m, theme: r, classNames: c, props: l }),
    O({ selector: n, stylesCtx: m, theme: r, classNames: C, props: l }),
    D({ selector: n, stylesCtx: m, options: a, props: l, theme: r }),
    J({ rootSelector: S, selector: n, className: g }),
    K({ selector: n, classes: f, unstyled: t || y }),
    N && !y && Q({
      themeName: e,
      classNamesPrefix: u,
      selector: n,
      withStaticClass: a == null ? void 0 : a.withStaticClass
    }),
    a == null ? void 0 : a.className
  );
}
function k({
  theme: r,
  themeName: a,
  props: e,
  stylesCtx: n,
  selector: u
}) {
  return a.map(
    (c) => {
      var f;
      return T({
        theme: r,
        styles: (f = r.components[c]) == null ? void 0 : f.styles,
        props: e,
        stylesCtx: n
      })[u];
    }
  ).reduce((c, f) => s(s({}, c), f), {});
}
function M({ style: r, theme: a }) {
  return Array.isArray(r) ? [...r].reduce(
    (e, n) => s(s({}, e), M({ style: n, theme: a })),
    {}
  ) : typeof r == "function" ? r(a) : r == null ? {} : r;
}
function x(r) {
  return r.reduce((a, e) => (e && Object.keys(e).forEach((n) => {
    a[n] = s(s({}, a[n]), F(e[n]));
  }), a), {});
}
function h({
  vars: r,
  varsResolver: a,
  theme: e,
  props: n,
  stylesCtx: u,
  selector: c,
  themeName: f,
  headless: t
}) {
  var g;
  return (g = x([
    t ? {} : a == null ? void 0 : a(e, n, u),
    ...f.map((S) => {
      var l, m, N;
      return (N = (m = (l = e.components) == null ? void 0 : l[S]) == null ? void 0 : m.vars) == null ? void 0 : N.call(m, e, n, u);
    }),
    r == null ? void 0 : r(e, n, u)
  ])) == null ? void 0 : g[c];
}
function o({
  theme: r,
  themeName: a,
  selector: e,
  options: n,
  props: u,
  stylesCtx: c,
  rootSelector: f,
  styles: t,
  style: g,
  vars: S,
  varsResolver: l,
  headless: m,
  withStylesTransform: N
}) {
  return s(s(s(s(s(s({}, !N && k({ theme: r, themeName: a, props: u, stylesCtx: c, selector: e })), !N && T({ theme: r, styles: t, props: u, stylesCtx: c })[e]), !N && T({ theme: r, styles: n == null ? void 0 : n.styles, props: (n == null ? void 0 : n.props) || u, stylesCtx: c })[e]), h({ theme: r, props: u, stylesCtx: c, vars: S, varsResolver: l, selector: e, themeName: a, headless: m })), f === e ? M({ style: g, theme: r }) : null), M({ style: n == null ? void 0 : n.style, theme: r }));
}
function p({ props: r, stylesCtx: a, themeName: e }) {
  var f;
  const n = P(), u = (f = G()) == null ? void 0 : f();
  return {
    getTransformedStyles: (t) => u ? [
      ...t.map(
        (S) => u(S, { props: r, theme: n, ctx: a })
      ),
      ...e.map(
        (S) => {
          var l;
          return u((l = n.components[S]) == null ? void 0 : l.styles, { props: r, theme: n, ctx: a });
        }
      )
    ].filter(Boolean) : [],
    withStylesTransform: !!u
  };
}
function ua({
  name: r,
  classes: a,
  props: e,
  stylesCtx: n,
  className: u,
  style: c,
  rootSelector: f = "root",
  unstyled: t,
  classNames: g,
  styles: S,
  vars: l,
  varsResolver: m
}) {
  const N = P(), y = H(), C = I(), b = U(), A = (Array.isArray(r) ? r : [r]).filter((i) => i), { withStylesTransform: _, getTransformedStyles: V } = p({
    props: e,
    stylesCtx: n,
    themeName: A
  });
  return (i, d) => ({
    className: R({
      theme: N,
      options: d,
      themeName: A,
      selector: i,
      classNamesPrefix: y,
      classNames: g,
      classes: a,
      unstyled: t,
      className: u,
      rootSelector: f,
      props: e,
      stylesCtx: n,
      withStaticClasses: C,
      headless: b,
      transformedStyles: V([d == null ? void 0 : d.styles, S])
    }),
    style: o({
      theme: N,
      themeName: A,
      selector: i,
      options: d,
      props: e,
      stylesCtx: n,
      rootSelector: f,
      styles: S,
      style: c,
      vars: l,
      varsResolver: m,
      headless: b,
      withStylesTransform: _
    })
  });
}
export {
  E as a,
  T as r,
  ua as u
};
